import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Logout = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      fill={fill}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      width={Sizes[size]}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M 11.300781 3.898438 C 11.699219 3.5 12.300781 3.398438 12.699219 3.800781 C 14.199219 5.101562 15 7 15 9 C 15.011719 10.859375 14.277344 12.648438 12.960938 13.960938 C 11.648438 15.277344 9.859375 16.011719 8 16 C 6.140625 16.011719 4.351562 15.277344 3.039062 13.960938 C 1.722656 12.648438 0.988281 10.859375 1 9 C 1 7 1.898438 5.101562 3.398438 3.800781 C 3.828125 3.480469 4.421875 3.523438 4.800781 3.898438 C 5.101562 4.300781 5.101562 4.898438 4.699219 5.300781 C 3.601562 6.199219 3 7.601562 3 9 C 3 11.800781 5.199219 14 8 14 C 10.800781 14 13 11.800781 13 9 C 13 7.601562 12.398438 6.199219 11.398438 5.300781 C 11 4.898438 10.898438 4.300781 11.300781 3.898438 Z M 9 0 L 9 6 L 7 6 L 7 0 Z M 9 0 " />
    </svg>
  );
};

Logout.displayName = 'Logout';
